var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gamepad_2_",
    "data-name": "gamepad (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.389,
    height: 31.389,
    viewBox: "0 0 31.389 31.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4520",
    "data-name": "Path 4520",
    d: "M241.92,9.932a.92.92,0,0,1-.92-.92V4.6A4.6,4.6,0,0,1,245.6,0h11.1a.92.92,0,1,1,0,1.839H245.6A2.762,2.762,0,0,0,242.839,4.6V9.012A.92.92,0,0,1,241.92,9.932Z",
    transform: "translate(-226.225)",
    fill: "#45f6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(15.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4521",
    "data-name": "Path 4521",
    d: "M270.775,0h-11.1A4.594,4.594,0,0,0,256,1.842V9.932a.92.92,0,0,0,.92-.92V4.6a2.762,2.762,0,0,1,2.759-2.759h11.1a.92.92,0,1,0,0-1.839Z",
    transform: "translate(-256)",
    fill: "#2ebeef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4522",
    "data-name": "Path 4522",
    d: "M26.84,127.13a4.575,4.575,0,0,1-4.251-2.928l-1.432-3.755-3.632-2.226H13.865l-3.632,2.226L8.8,124.2a4.55,4.55,0,0,1-8.8-1.62v-12.1a8.629,8.629,0,0,1,2.1-5.648,8.108,8.108,0,0,1,5.32-2.792,8.2,8.2,0,0,1,6.046,1.8h4.454a8.2,8.2,0,0,1,6.046-1.8,8.107,8.107,0,0,1,5.32,2.793,8.632,8.632,0,0,1,2.1,5.649v12.1A4.555,4.555,0,0,1,26.84,127.13Z",
    transform: "translate(0 -95.741)",
    fill: "#524798"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(15.695 6.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4523",
    "data-name": "Path 4523",
    d: "M269.594,104.83a8.106,8.106,0,0,0-5.32-2.793,8.2,8.2,0,0,0-6.046,1.8H256V118.22h1.829l3.633,2.226,1.432,3.755a4.55,4.55,0,0,0,8.8-1.621v-12.1A8.632,8.632,0,0,0,269.594,104.83Z",
    transform: "translate(-256 -101.994)",
    fill: "#38336b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(2.789 9.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4524",
    "data-name": "Path 4524",
    d: "M241.92,207.518a.92.92,0,0,1-.92-.92V202.92a.92.92,0,0,1,1.839,0V206.6A.92.92,0,0,1,241.92,207.518Z",
    transform: "translate(-229.015 -199.548)",
    fill: "#38336b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(16.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    transform: "translate(0 3.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4525",
    "data-name": "Path 4525",
    d: "M418.646,223.839H417.42a.92.92,0,1,1,0-1.839h1.226a.92.92,0,1,1,0,1.839Z",
    transform: "translate(-410.369 -222)",
    fill: "#2ebeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4526",
    "data-name": "Path 4526",
    d: "M318.646,223.839H317.42a.92.92,0,0,1,0-1.839h1.226a.92.92,0,1,1,0,1.839Z",
    transform: "translate(-316.5 -222)",
    fill: "#2ebeef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(3.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M377.42,165.065a.92.92,0,0,1-.92-.92V162.92a.92.92,0,1,1,1.839,0v1.226A.92.92,0,0,1,377.42,165.065Z",
    transform: "translate(-376.5 -162)",
    fill: "#2ebeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    d: "M377.42,265.065a.92.92,0,0,1-.92-.92V262.92a.92.92,0,1,1,1.839,0v1.226A.92.92,0,0,1,377.42,265.065Z",
    transform: "translate(-376.5 -255.869)",
    fill: "#2ebeef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(0 3.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    d: "M47.646,223.839H46.42a.92.92,0,1,1,0-1.839h1.226a.92.92,0,1,1,0,1.839Z",
    transform: "translate(-45.5 -222)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M147.646,223.839H146.42a.92.92,0,1,1,0-1.839h1.226a.92.92,0,1,1,0,1.839Z",
    transform: "translate(-139.369 -222)",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(3.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M106.42,165.065a.92.92,0,0,1-.92-.92V162.92a.92.92,0,1,1,1.839,0v1.226A.92.92,0,0,1,106.42,165.065Z",
    transform: "translate(-105.5 -162)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M106.42,265.065a.92.92,0,0,1-.92-.92V262.92a.92.92,0,1,1,1.839,0v1.226A.92.92,0,0,1,106.42,265.065Z",
    transform: "translate(-105.5 -255.869)",
    fill: "#f9f9f9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M281.806,325.324A2.83,2.83,0,0,1,279,322.412a2.912,2.912,0,0,1,5.824,0A3.006,3.006,0,0,1,281.806,325.324Z",
    transform: "translate(-264.685 -309.844)",
    fill: "#e4e4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(15.695 12.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M256,202v5.518a.92.92,0,0,0,.92-.92V202.92A.92.92,0,0,0,256,202Z",
    transform: "translate(-256 -202)",
    fill: "#2e2654"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M138,322.412a2.912,2.912,0,0,1,5.824,0,2.83,2.83,0,0,1-2.806,2.912A3.006,3.006,0,0,1,138,322.412Z",
    transform: "translate(-129.54 -299.912)",
    fill: "#f9f9f9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllGames);
export default __webpack_public_path__ + "static/media/all-games.5e859d8a923603e9c450914c1f925e51.svg";
export { ForwardRef as ReactComponent };